export default __webpack_public_path__ + "static/media/graignes.464479a9.jpg";